// Sorting board rows by one column. Pure functions (ordenLogica.test.mjs).
//
// `orden` is { campo, dir } -- campo a column id (or a fixed field id, as in
// filtrosLogica), dir 'asc' | 'desc' -- or null for the load order.

import { valorDe } from './filtrosLogica.js'

const blank = (v) => v == null || String(v).trim() === ''

// Natural and forgiving: "E2" before "E10", "cardán" next to "Cardan".
const texto = new Intl.Collator('es', { numeric: true, sensitivity: 'base' })

function comparar(a, b, tipo) {
  if (tipo === 'numero' || tipo === 'archivo') {
    const x = Number(String(a).replace(',', '.')), y = Number(String(b).replace(',', '.'))
    if (!Number.isNaN(x) && !Number.isNaN(y)) return x - y
  }
  if (tipo === 'fecha') return String(a) < String(b) ? -1 : String(a) > String(b) ? 1 : 0   // ISO
  return texto.compare(String(a), String(b))
}

// A new array; ties keep their current order. Empty cells always go last,
// whichever the direction -- a sort is for finding values, not blanks.
export function ordenar(filas, orden, columnas) {
  if (!orden) return filas
  const col = columnas.find(c => String(c.id) === String(orden.campo))
  if (!col) return filas
  const signo = orden.dir === 'desc' ? -1 : 1
  return filas
    .map((f, i) => ({ f, i, v: valorDe(f, col) }))
    .sort((a, b) => {
      const va = blank(a.v), vb = blank(b.v)
      if (va || vb) return va === vb ? a.i - b.i : (va ? 1 : -1)
      return signo * comparar(a.v, b.v, col.tipo) || a.i - b.i
    })
    .map(x => x.f)
}

// Next state for a header's sort buttons: pick a direction, or clear it.
export function siguienteOrden(actual, campo, dir) {
  if (!dir) return actual && String(actual.campo) === String(campo) ? null : actual
  return { campo, dir }
}
